"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.upgrade.message': 'Ulepsz swój plan konta, aby uzyskać dostęp do tej funkcji.',
    'limits.upgrade.link': 'Ulepsz Teraz',
};
